import { render } from "./NewProductsModal.vue?vue&type=template&id=6d7f3c10&scoped=true"
import script from "./NewProductsModal.vue?vue&type=script&lang=js"
export * from "./NewProductsModal.vue?vue&type=script&lang=js"

import "./NewProductsModal.vue?vue&type=style&index=0&id=6d7f3c10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7f3c10"]])

export default __exports__